import * as z from 'zod';
import { extractionStatusSchema, ExtractionStatus, extractionErrorTypeSchema } from '../../../enums.mjs';
import { fileId, emailSubmissionId } from '../../opaque.mjs';
import { DocumentTypeField, BondRequestExtractionOutputFull, BondRequestExtractionOutputMinimal, BondRequestExtractionOutputEmailFull } from './bond-request-extraction-output.mjs';

const bondRequestExtractionScopeDef = ["full", "minimal"];
const bondRequestExtractionScopeSchema = z.enum(bondRequestExtractionScopeDef);
const commonResultFields = {
    status: extractionStatusSchema.extract([ExtractionStatus.Completed, ExtractionStatus.Partial]),
    processingSessionId: z.string().nullable(),
};
const submissionNarrativeDocumentTypeField = z.object({
    value: z.literal("submission_narrative"),
    explanation: z.string().nullish(),
});
const emailThreadDocumentTypeField = z.object({
    value: z.literal("email_thread"),
    explanation: z.string().nullish(),
});
const bondRequestFileFullResultSchema = z.object({
    source: z.literal("file"),
    fileId: fileId,
    emailSubmissionId: emailSubmissionId.optional(),
    scope: z.literal("full"),
    output: BondRequestExtractionOutputFull.optional(),
    documentType: DocumentTypeField,
    ...commonResultFields,
});
const bondRequestFileMinimalResultSchema = z.object({
    source: z.literal("file"),
    fileId: fileId,
    emailSubmissionId: emailSubmissionId.optional(),
    scope: z.literal("minimal"),
    output: BondRequestExtractionOutputMinimal.optional(),
    documentType: DocumentTypeField,
    ...commonResultFields,
});
const bondRequestSubmissionNarrativeFullResultSchema = z.object({
    source: z.literal("submission_narrative"),
    submissionId: z.string().min(1),
    scope: z.literal("full"),
    output: BondRequestExtractionOutputFull.optional(),
    documentType: submissionNarrativeDocumentTypeField,
    ...commonResultFields,
});
const bondRequestSubmissionNarrativeMinimalResultSchema = z.object({
    source: z.literal("submission_narrative"),
    submissionId: z.string().min(1),
    scope: z.literal("minimal"),
    output: BondRequestExtractionOutputMinimal.optional(),
    documentType: submissionNarrativeDocumentTypeField,
    ...commonResultFields,
});
const bondRequestEmailThreadFullResultSchema = z.object({
    source: z.literal("email_thread"),
    gmailThreadId: z.string().min(1),
    scope: z.literal("full"),
    output: BondRequestExtractionOutputEmailFull.optional(),
    documentType: emailThreadDocumentTypeField,
    ...commonResultFields,
});
const bondRequestFileResultSchema = z.discriminatedUnion("scope", [
    bondRequestFileFullResultSchema,
    bondRequestFileMinimalResultSchema,
]);
const bondRequestSubmissionNarrativeResultSchema = z.discriminatedUnion("scope", [
    bondRequestSubmissionNarrativeFullResultSchema,
    bondRequestSubmissionNarrativeMinimalResultSchema,
]);
var BondRequestExtractionResultPayload;
(function (BondRequestExtractionResultPayload) {
    BondRequestExtractionResultPayload.schema = z.discriminatedUnion("source", [
        bondRequestFileResultSchema,
        bondRequestSubmissionNarrativeResultSchema,
        bondRequestEmailThreadFullResultSchema,
    ]);
})(BondRequestExtractionResultPayload || (BondRequestExtractionResultPayload = {}));
const failureBaseFields = {
    status: z.literal(ExtractionStatus.Failed),
    errorType: extractionErrorTypeSchema,
    errorMessage: z.string(),
};
const bondRequestFileFailureSchema = z.object({
    source: z.literal("file"),
    fileId: fileId,
    emailSubmissionId: emailSubmissionId.optional(),
    ...failureBaseFields,
});
const bondRequestSubmissionNarrativeFailureSchema = z.object({
    source: z.literal("submission_narrative"),
    submissionId: z.string().min(1),
    ...failureBaseFields,
});
const bondRequestEmailThreadFailureSchema = z.object({
    source: z.literal("email_thread"),
    gmailThreadId: z.string().min(1),
    ...failureBaseFields,
});
var BondRequestExtractionFailurePayload;
(function (BondRequestExtractionFailurePayload) {
    BondRequestExtractionFailurePayload.schema = z.discriminatedUnion("source", [
        bondRequestFileFailureSchema,
        bondRequestSubmissionNarrativeFailureSchema,
        bondRequestEmailThreadFailureSchema,
    ]);
})(BondRequestExtractionFailurePayload || (BondRequestExtractionFailurePayload = {}));
var BondRequestExtractionWebhookPayload;
(function (BondRequestExtractionWebhookPayload) {
    BondRequestExtractionWebhookPayload.schema = z.union([
        BondRequestExtractionResultPayload.schema,
        BondRequestExtractionFailurePayload.schema,
    ]);
})(BondRequestExtractionWebhookPayload || (BondRequestExtractionWebhookPayload = {}));

export { BondRequestExtractionFailurePayload, BondRequestExtractionResultPayload, BondRequestExtractionWebhookPayload, bondRequestEmailThreadFailureSchema, bondRequestEmailThreadFullResultSchema, bondRequestExtractionScopeDef, bondRequestExtractionScopeSchema, bondRequestFileFailureSchema, bondRequestFileFullResultSchema, bondRequestFileMinimalResultSchema, bondRequestSubmissionNarrativeFailureSchema, bondRequestSubmissionNarrativeFullResultSchema, bondRequestSubmissionNarrativeMinimalResultSchema };
